export default __webpack_public_path__ + "static/media/compas_project_formation_obtenue.039b8909.gif";